import React, { useState, useEffect } from "react";
import moment from "moment-hijri";
import "moment/locale/fr";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import MainCalculatorsList from "../HumanCalculator/MainCalculators";

const TITLE = "Date d'Aujourd'hui Grégorien et Hégirien - Connaître la Date Actuelle";
const DESCRIPTION =
  "Date d pour calculer des dates, durees ou ages avec precision. Outil pratique pour vos demarches administratives, votre organisation personnelle et vos besoins du quotidien.";
const KEYWORDS =
  "date d, calculatrice date d, calcul en ligne, age, date, temps, calendrier, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/current-date/";

const frenchMonths = [
  "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
  "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
];

const frenchDays = [
  "Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"
];

const hijriMonths = [
  "Muharram", "Safar", "Rabi' al-awwal", "Rabi' al-Thani",
  "Jumada al-awwal", "Jumada al-Thani", "Rajab", "Sha'ban",
  "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah"
];

moment.locale("fr");

function CurrentDateDisplay() {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);

  const dayName = frenchDays[currentTime.getDay()];
  const day = currentTime.getDate();
  const month = frenchMonths[currentTime.getMonth()];
  const year = currentTime.getFullYear();
  const gregorianDate = `${dayName}, ${day} ${month} ${year}`;

  let hours = currentTime.getHours();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  const minutes = currentTime.getMinutes().toString().padStart(2, "0");
  const seconds = currentTime.getSeconds().toString().padStart(2, "0");
  const gregorianTime = `${hours}:${minutes}:${seconds} ${ampm}`;

  const hijriMoment = moment(currentTime);
  const hijriDay = hijriMoment.iDate();
  const hijriMonthIndex = hijriMoment.iMonth();
  const hijriMonth = hijriMonths[hijriMonthIndex];
  const hijriYear = hijriMoment.iYear();
  const hijriWeekday = hijriMoment.format("dddd");
  const hijriDate = `${hijriWeekday}, ${hijriDay} ${hijriMonth} ${hijriYear}`;
  const hijriTime = hijriMoment.format("hh:mm:ss A");

  return (
    <div style={{ direction: "ltr" }}>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>

      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center p-3">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>

          <div className="border border-light p-3">
            <p>
              Affichage de la date et de l'heure actuelles selon le calendrier grégorien et le calendrier hégirien en temps réel. Les informations se mettent à jour chaque seconde.
            </p>
            <hr />
            <MobileUnderCalAds />

            <div className="row mt-4">
              <div className="col-md-6">
                <div className="card">
                  <div className="card-header bg-success text-white">
                    <h5 className="mb-0">Calendrier Grégorien</h5>
                  </div>
                  <div className="card-body text-center">
                    <div style={{ fontSize: "28px", fontWeight: "bold", color: "#28a745", marginBottom: "10px" }}>
                      {gregorianDate}
                    </div>
                    <div style={{ fontSize: "24px", color: "#333" }}>
                      {gregorianTime}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-6">
                <div className="card">
                  <div className="card-header bg-info text-white">
                    <h5 className="mb-0">Calendrier Hégirien</h5>
                  </div>
                  <div className="card-body text-center">
                    <div style={{ fontSize: "28px", fontWeight: "bold", color: "#17a2b8", marginBottom: "10px" }}>
                      {hijriDate}
                    </div>
                    <div style={{ fontSize: "24px", color: "#333" }}>
                      {hijriTime}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-4">
              <h4>Informations de Temps Détaillées:</h4>
              <div className="row">
                <div className="col-md-6">
                  <h6 style={{ fontWeight: "bold", color: "#28a745" }}>Grégorien:</h6>
                  <ul>
                    <li><strong>Jour de la semaine:</strong> {dayName}</li>
                    <li><strong>Jour du mois:</strong> {day}</li>
                    <li><strong>Mois:</strong> {month}</li>
                    <li><strong>Année:</strong> {year}</li>
                    <li><strong>Heure:</strong> {gregorianTime}</li>
                  </ul>
                </div>
                <div className="col-md-6">
                  <h6 style={{ fontWeight: "bold", color: "#17a2b8" }}>Hégirien:</h6>
                  <ul>
                    <li><strong>Jour de la semaine:</strong> {hijriWeekday}</li>
                    <li><strong>Jour du mois:</strong> {hijriDay}</li>
                    <li><strong>Mois:</strong> {hijriMonth}</li>
                    <li><strong>Année:</strong> {hijriYear}</li>
                    <li><strong>Heure:</strong> {hijriTime}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <br />
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
          <RelatedLinks />
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Affichage de la date et heure actuelles</h3></div>
              <div className="info-section-body">
                <p>Cette page affiche la date et l’heure en temps réel selon votre fuseau horaire local. La date est affichée dans les deux calendriers — grégorien et hégirien — pour faciliter la correspondance entre les deux systèmes. L’heure est mise à jour automatiquement sans rechargement de la page.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Fuseaux horaires et heure universelle</h3></div>
              <div className="info-section-body">
                <p>Le monde est divisé en 24 fuseaux horaires, chacun décalé d’une heure par rapport au suivant. L’heure de référence mondiale est l’UTC (Temps Universel Coordonné), anciennement appelé GMT. La France est à UTC+1 en hiver et UTC+2 en été (heure d’été européenne). Le décalage peut créer des confusions lors de réunions internationales ou de voyages.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CurrentDateDisplay;
